export default "__VITE_ASSET__1a01a807__"